import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import {withRouter} from "react-router-dom";
import AddCircle from '@material-ui/icons/AddCircleOutline';
import { inject, observer } from 'mobx-react';
import _ from 'lodash'
import {pending} from '../stores/State'
import moment from 'moment'

@inject('store')
@observer
class LogisticPlans extends Component {
  constructor() {
    super();
    this.state = {
      rowsPerPage: 10,
      page: 0
    }
  }

  componentDidMount(){
    this.fetchData();
  }
  componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props, nextProps)) this.fetchData(nextProps.accountId);
  }
  
  fetchData(accountId){
    const store  = this.props.store.logisticPlanStore;
    const { rowsPerPage, page } = this.state;
    store.fetchLogisticPlans(accountId || this.props.accountId, rowsPerPage, page);
  }

  handleRowClick(logisticPlan){
    this.props.history.push(`/accounts/${this.props.accountId}/logistic_plans/${logisticPlan.id}`);    
  }

  onChangePage = (event, page) => {
    this.setState({ page }, () => {
      this.fetchData();
    })
  }

  onChangeRowsPerPage = (event,) => {
    this.setState({ rowsPerPage: event.target.value }), () => {
      this.fetchData();
    };
  }

  render() {
    const { classes } = this.props;
    const store  = this.props.store.logisticPlanStore;
    const { page, rowsPerPage} = this.state;

    return (
      <Paper className={classes.paper}>
        <Typography variant='subheading'>
          Logistic plans 
        </Typography>
        { store.logisticPlansState === pending && <CircularProgress /> }
        { store.logisticPlans && 
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Number of pickups</TableCell>
                <TableCell>Locations</TableCell>
                <TableCell>Created at</TableCell>
                <TableCell>Destination</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {store.logisticPlans.results.map(logisticPlan => {
                return (
                  <TableRow className={logisticPlan.archived_at && classes.archivedCell} key={logisticPlan.id} hover onClick={()=>this.handleRowClick(logisticPlan)}>
                    <TableCell>{logisticPlan.pickups.length}</TableCell>
                    <TableCell>{logisticPlan.pickups.map(pickup => pickup.inventory_location.name).join(', ')}</TableCell>
                    <TableCell>{moment(logisticPlan.created_at).format('lll')}</TableCell>
                    <TableCell>{logisticPlan.destination.name}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={store.logisticPlans.count}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.onChangePage}
                  onChangeRowsPerPage={this.onChangeRowsPerPage}
                />
              </TableRow>
              <TableRow>
                <TableCell colSpan="3">
                  <Button variant="contained" className={classes.button} color='primary' onClick={()=>this.props.history.push(`/accounts/${this.props.accountId}/logistic_plans/new`)}>New logistic plan<AddCircle className={classes.icon}/></Button>
                </TableCell>
                </TableRow>
            </TableFooter>
          </Table> }
        </Paper>
    );
  }
}

const styles = theme => ({
  paper: {
    padding: 20
  },
  button:{
    margin: 5
  },
  icon:{
    marginLeft: 5
  },
  archivedCell: {
    opacity: 0.2
  }
});

LogisticPlans.propTypes = {
  accountId: PropTypes.number
}

export default withRouter(withStyles(styles)(LogisticPlans));



// WEBPACK FOOTER //
// ./src/components/LogisticPlans.js